import { GetStaticProps } from 'next'
import { paths } from '@/constants/paths'
import { ImpactContextProvider } from '@/contexts/ImpactContext'
import { PaymentsContextProvider } from '@/contexts/PaymentsContext'
import { Seo } from '@/layout/Seo'
import { useCanonicalUrl } from '@/layout/Seo/useCanonicalUrl'
import { NextPageWithLayout, NotificationsLayout } from '@/layouts'
import { getGenericStaticPaths } from '@/utils/GetGenericStaticPaths'
import { getLocaleFromParams } from '@/utils/LocaleUtil'
import { getStaticPropsErrorHandler, getUrlFromThisFilePath } from '@/utils/nextUtils/nextErrorHandlers'
import { useTranslate } from '@/utils/translate/translate-client'
import { loadTranslations } from '@/utils/translate/translate-server'
import { NotificationsView } from '@/views/NotificationsView'

export const NotificationsPage: NextPageWithLayout = () => {
  const { t } = useTranslate('common')
  const url = useCanonicalUrl(paths.notifications.index)
  const title = t('angelStudiosNotificationsMetaTitle', 'Notifications | Angel Studios')
  const description = t('angelStudiosNotificationsMetaDescription', 'Manage notifications')
  const openGraph = {
    description,
    title,
  }
  return (
    <>
      <Seo canonical={url} description={description} noindex nofollow openGraph={openGraph} title={title} />
      <PaymentsContextProvider>
        <ImpactContextProvider>
          <NotificationsView />
        </ImpactContextProvider>
      </PaymentsContextProvider>
    </>
  )
}

NotificationsPage.getLayout = (page) => {
  return <NotificationsLayout>{page}</NotificationsLayout>
}

export const getStaticProps: GetStaticProps = async ({ params }) =>
  getStaticPropsErrorHandler({ requestUrl: getUrlFromThisFilePath(params) }, async () => {
    const locale = getLocaleFromParams(params)
    return {
      props: {
        ...(await loadTranslations(locale, ['common', 'account'])),
      },
    }
  })

export const getStaticPaths = getGenericStaticPaths

export default NotificationsPage
